var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"lv-toggle-chip",class:{
    'lv-toggle-chip--active': _vm.value && !_vm.disabled,
    'lv-toggle-chip--disabled': _vm.disabled,
  },attrs:{"type":"button","disabled":_vm.disabled,"aria-pressed":_vm.value ? 'true' : 'false'},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('input', !_vm.value)}}},[_c('i',{staticClass:"lv-toggle-chip__icon",class:_vm.value ? 'icon-check' : 'icon-add'}),(_vm.text)?_c('span',{staticClass:"lv-toggle-chip__text"},[_vm._v(_vm._s(_vm.$t(_vm.text)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }